import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { ColumnContainer, RowContainer } from "../../../styles/containers/styles";
import { ListItem, ListItemBold, ListItemHead, ListItemQuarter, ToolTip, ToolTipContainer } from "../../../styles/list/styles";
import Layout from "../../common/layout";
import { Section, Tab, TabContainer, TabHeader, TabLink } from "./styels";
import moment from "moment";
import { useTranslation } from "react-i18next";
import { CarIcon, DateIcon, DurationIcon, FileIcon, LocationIcon, QuestionIcon } from "../../../../icons";
import WhistleblowingComments from "./whistleblowingComments";
const Track = (props) => {
  const { t } = useTranslation();
  //to update the page title
  useEffect(() => {
    document.title = `${t("status")} - Whistleblowing | Perso Base`;
  }, [t]);
  // Use the useTranslation hook from react-i18next to handle translations

  const [showTooltip, setShowTooltip] = useState(false);
  const [activeTab, setActiveTab] = useState("Details");
  const themeColors = useSelector((state) => state.themeColors);

  // const currentDate = new Date();
  // const parkingDateObject = new Date(props.vehicle.data.data.dateOfParkingProcess);
  // const endDate = new Date(parkingDateObject.getTime() + (currentDate.getTime() - parkingDateObject.getTime()));
  // const duration = currentDate.getTime() - parkingDateObject.getTime();
  // const totalDuration = duration / 60000;
  // const days = Math.floor(duration / (1000 * 60 * 60 * 24));
  // const hours = Math.floor((duration % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
  // const minutes = Math.floor((duration % (1000 * 60 * 60)) / (1000 * 60));

  // const [lat] = useState(props.vehicle.data.data.map.latitude);
  // const [lng] = useState(props.vehicle.data.data.map.longitude);
  // const mapRef = useRef(null);
  // useEffect(() => {
  //   //setting google map latitute and longitude
  //   const map = new window.google.maps.Map(mapRef.current, {
  //     center: { lat, lng },
  //     zoom: 1,
  //   });
  //   //adding that in to maps in the window
  //   new window.google.maps.Marker({ position: { lat, lng }, map });
  // }, [lat, lng]);
  const currency = "EUR";
  const data = props.trackStatus;
  // const parkingDuration = totalDuration > 120 ? (days > 0 ? days + `d, ` : ``) + (hours > 0 ? hours + `h, ` : ``) + (minutes + t("m")) : totalDuration.toFixed(0) + ` ` + t("minutes");
  return (
    <TabContainer>
      <div>
      <TabHeader>
        <TabLink theme={themeColors} className="active">
          {t("Details")}
        </TabLink>
      </TabHeader>
      <Tab >
        <RowContainer>
          <ColumnContainer>
            <Section>
              <ListItemHead> {t("yourTrackStatus")}</ListItemHead>
              <ListItem style={{color: 'red'}}>
                <span>{t("status")}</span> {t(data?.status)}
              </ListItem>
              <ListItem>
                <span>{t("date")}</span> {moment(data?.createdAt).format("DD.MM.YYYY")}
              </ListItem>
              <ListItem>
                <span>{t("title")}</span> {data?.title}
              </ListItem>
              <ListItem>
                <span>{t("description")}</span> {data?.description}
              </ListItem>
              <ListItem>
                <span>{t("Location")}</span> {data?.location?.title}
              </ListItem>
              {data?.category?._id && <ListItem>
                <span>{t("Category")}</span> {data.category[localStorage.getItem("_lang")]}
              </ListItem>}
              {/* <ListItem>
                <DurationIcon /> {moment(data.parkingStartDate).format("h:mm A") + ` - ` + moment(data.parkingEndDate).format("h:mm A")}
              </ListItem> */}
            </Section>
            {/* <Section>
              <ListItemHead> {t("yourParkingTime")}</ListItemHead>
              <ListItem>
                {t("yourParkingTime")} : {data.parkingDuration} {t("minutes")}
              </ListItem>
              <ListItem>
                {t("allowedParkingTime")} : {data.allowedParkingDuration} {t("minutes")}
              </ListItem>
            </Section> */}
          </ColumnContainer>
          {/* <Section>
            <ListItemBold>
              <ListItemQuarter className="head">{t("dueAmount")}</ListItemQuarter>
              <ListItemQuarter className="head">{t("paymentDate")}</ListItemQuarter>
              <ListItemQuarter className="head">{t("status")}</ListItemQuarter>
            </ListItemBold>
            <ListItem>
              <ListItemQuarter style={{fontSize:'18px'}}>
                {paymentDetails.dueAmount + ` ` + currency}
                <ToolTipContainer onMouseEnter={() => setShowTooltip(true)} onMouseLeave={() => setShowTooltip(false)}>
                  <QuestionIcon />
                  {showTooltip && (
                    <ToolTip>
                      <ListItemQuarter>{t("contractualPenalty") + ` : ` + paymentDetails.contractualPenalty + ` ` + currency}</ListItemQuarter>
                      <ListItemQuarter>{t("handlingFee") + ` : ` + paymentDetails.handlingFee + ` ` + currency}</ListItemQuarter>
                      <ListItemQuarter>{t("registrationFee") + ` : ` + paymentDetails.registrationFee + ` ` + currency}</ListItemQuarter>
                    </ToolTip>
                  )}
                </ToolTipContainer>
              </ListItemQuarter>
              <ListItemQuarter style={{fontSize:'18px'}}>{paymentDetails.paymentDate ? moment(paymentDetails.paymentDate).format("DD.MM.YYYY") : "notAvailable"}</ListItemQuarter>
              <ListItemQuarter className={paymentDetails.paymentStatus}>{`${t(paymentDetails.paymentStatus)}`}</ListItemQuarter>
            </ListItem>
          </Section> */}
        </RowContainer>
      </Tab>
      </div>
      <div>
        <TabHeader>
        <TabLink theme={themeColors} >
          {"Whistleblowing " + t("comments")}
        </TabLink>
        </TabHeader>
      <Tab >
        <RowContainer>
          <ColumnContainer style={{width:'100%'}}>
          <WhistleblowingComments t={t} data={data} {...props} />
            {/* <Section>
              <ListItemBold>{t("parkingSpot")}</ListItemBold>
              <ListItem>
                <LocationIcon /> {data.parkingLotAddress}
              </ListItem>
              <ListItemBold>{t("scope")}</ListItemBold>
              <ListItem>
                <DateIcon /> {data.hoursOfValidity}
              </ListItem>
              <ListItemBold>{t("allowedParkingTime")}</ListItemBold>
              <ListItem>
                <DurationIcon /> {data.allowedParkingDuration} {t("minutes")}
              </ListItem>
            </Section> */}
            {/* <Section>
              <GoogleMap/>
            </Section> */}
          </ColumnContainer>
        </RowContainer>
      </Tab>
      </div>
    </TabContainer>
  );
};
// exporting the page with parent container layout..
export default Layout(Track);
